module.exports = __webpack_public_path__ + "static/media/Illus-BowlFull.e8c0f78f.png";